import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import {formatNumber, filterItemsSearch} from '../../../../utilities/utilities'
import AutoCompleteList from '../../../../layout/AutoCompleteList'
import CloseButton from '../../../../layout/close_button/CloseButton'
import { DiscountFormStyle, DiscountInputStyle, DiscountsListStyle } from './css/DiscountFormStyle'

function DiscountInput(props) {
  const idNumberRef = useRef(null)
  const [discount, setDiscount, resetDiscount, initDiscount] = props.discount
  const [discountsList, setDiscountsList] = props.discountsList
  const [editDiscount, setEditDiscount] = props.editDiscount
  const editDiscountItemIndex = props.editDiscountItemIndex[0]
  const { totalAmount, totalVATAmount, discounts, calcDiscountsTotal, removeSelection } = props
  const [discountsACList, setDiscountsACList] = useState(null)
  const [keyPressed, setKeyPressed] = useState(false)
  const [itemClicked, setItemClicked] = useState(false)
  const [activeInput, setActiveInput] = useState(null)
  const [addOK, setAddOK] = useState(false)

  const onChange = (e) => {
    if ((!keyPressed) && (e.target.type !== 'number')) return

    setActiveInput(e.target.name)

    const total_amount = (discount.vat_exempted) ? (totalAmount - totalVATAmount) : totalAmount

    switch(e.target.name) {
      case 'percent_discount':
        setDiscount({
          ...discount,
          percent_discount: e.target.value,
          discount_amount: ((e.target.value/100) * total_amount).toFixed(2)
        })
        break
      case 'discount_amount':
        setDiscount({
          ...discount,
          discount_amount: e.target.value,
          percent_discount: parseFloat((e.target.value / total_amount) * 100).toFixed(2)
        })
        break
      case 'id_number':
      case 'discount_authority_name':
        const filteredItemList = filterItemsSearch(discounts.map(item => item[e.target.name]), e.target.value)
        setDiscountsACList(filteredItemList)
        if (e.target.name === 'id_number') setDiscount({ ...initDiscount, [e.target.name]: e.target.value })
        else setDiscount({ ...discount, [e.target.name]: e.target.value })
        break
      default:
        setDiscount({ ...discount, [e.target.name]: e.target.value })
    }
  }

  const onKeyDown = (e) => {
    const allowedElements = ['id_number', 'discount_authority_name']
    if (!allowedElements.find((item) => item === e.target.name)) {
      setKeyPressed(true)
      return
    }
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        setKeyPressed(false)
        break
      case 'Enter':
      case 'Tab':
      case 'Escape':
        setDiscountsACList([])
        ReactDOM.unmountComponentAtNode(document.getElementById(e.target.name+'-acl-container'))
        break
      default:
        setKeyPressed(e.key)
    }
  }

  const onClickAdd = (e) => {
    if (editDiscount) {
      removeSelection()
      discountsList[editDiscountItemIndex] = discount
      calcDiscountsTotal()
      setEditDiscount(false)
    } else {
      // Find first if the discount is already on the list
      if (discountsList.find(item => (
            (item.id_number === discount.id_number) &&
            (item.discount_authority_name === discount.discount_authority_name)
          )))
        alert('Same Discount ID Number and Discount Authority Name is already on the list.')
      else {
        setDiscountsList([ ...discountsList, discount ])
        resetDiscount()
      }
    }

    document.getElementById('id-number').focus()
  }

  const onClickCancel = (e) => {
    removeSelection()
    setEditDiscount(false)
    resetDiscount()
    document.getElementById('id-number').focus()
  }

  useEffect(() => idNumberRef.current.focus(), [])

  useEffect(() => { idNumberRef.current.focus() }, [discountsList])

  useEffect(() => {
    setAddOK (
      discount.id_number &&
      discount.account_holder_name &&
      discount.discount_authority_name &&
      (discount.percent_discount > 0)
    )
    return(() => setAddOK(false))
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discount])

  useEffect(() => {
    const allowedElements = ['id_number', 'discount_authority_name']

    if (!allowedElements.find(item => item === activeInput)) return

    if (activeInput)
      if (discountsACList.length > 0)
        ReactDOM.render(
          <AutoCompleteList
            valueSetter={(value) => setDiscount({ ...discount, [activeInput]: value })}
            keyPressed={keyPressed}
            setItemClicked={setItemClicked}
            items={discountsACList}
          />, document.getElementById(activeInput+'-acl-container')
        )
      else
        ReactDOM.unmountComponentAtNode(document.getElementById(activeInput+'-acl-container'))

    if (keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown') setKeyPressed(false)

    if (itemClicked) {
      setItemClicked(false)
      setDiscountsACList([])
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discount.id_number, discount.discount_authority_name, keyPressed, itemClicked])

  useEffect(() => {
    if (discount) {
      // Reverse the discounts(array) so we can find first the last occurence of the particular discount(id_number)
      const currentDiscount = discounts.reverse().find((discountInfo) => (discountInfo.id_number === discount.id_number))
      if (currentDiscount) {
        setDiscount({
          ...currentDiscount,
          discount_amount: ((currentDiscount.percent_discount / 100) * totalAmount)
        })
      }
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discount.id_number])

  useEffect(() => {
    if (discount) {
      const currentDiscount = discounts.find((discountInfo) => (discountInfo.discount_authority_name === discount.discount_authority_name))
      if (currentDiscount) {
        setDiscount({
          ...discount,
          vat_exempted: currentDiscount.vat_exempted,
          percent_discount: currentDiscount.percent_discount,
          discount_amount: (currentDiscount.vat_exempted)
          ? ((currentDiscount.percent_discount / 100) * (totalAmount - totalVATAmount))
          : ((currentDiscount.percent_discount / 100) * totalAmount)
        })
      }
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discount.discount_authority_name])

  useEffect(() => {
    const total_amount = (discount.vat_exempted) ? (totalAmount - totalVATAmount) : totalAmount
    const da = parseFloat((discount.percent_discount / 100) * total_amount).toFixed(2)
    const pd = parseFloat((da / total_amount) * 100).toFixed(2)

    if (pd + da !== 0) {
      setDiscount({
        ...discount,
        discount_amount: da,
        percent_discount: pd
      })
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discount.vat_exempted])

  return (
    <React.Fragment>
      <div id='discount-input-container'>
        <div id='sales-amount'>
          <label>Sales Amount</label>
          <span>
            <b>P {formatNumber(totalAmount)}</b>
          </span>
        </div>
        <div className='input-form-container'>
          <label>ID Number</label>
          <div className='input-container'>
            <input
              ref={idNumberRef}
              id='id-number'
              autoComplete='off'
              name='id_number'
              className='top-anchor'
              value={discount.id_number}
              onChange={onChange}
              onKeyDown={onKeyDown}
              type='text'/>
            <div id='id_number-acl-container' className='acl-container'></div>
          </div>
        </div>
        <div className='input-form-container'>
          <label>Account Holder's Name</label>
          <div className='input-container'>
            <input
              id='account-holder-name'
              name='account_holder_name'
              autoComplete='off'
              value={discount.account_holder_name}
              onKeyDown={onKeyDown}
              onChange={onChange}
              type='text'/>
          </div>
        </div>
        <div className='input-form-container'>
          <label>Discount Authority Name</label>
          <div className='input-container'>
            <input
              id='discount-authority-name'
              name='discount_authority_name'
              autoComplete='off'
              placeholder='Senior Citizen/PWD/Company Staff/Etc..'
              value={discount.discount_authority_name}
              onKeyDown={onKeyDown}
              onChange={onChange}
              type='text'/>
            <div id='discount_authority_name-acl-container' className='acl-container'></div>
          </div>
        </div>

        <div className='input-form-container'>
          <div className='checkbox-contianer'>
            <input
              type='checkbox'
              id='vat-exempted'
              name='vat-exempted'
              value={discount.vat_exempted}
              checked={discount.vat_exempted}
              onChange={(e) => { setDiscount({...discount, vat_exempted: e.target.checked}) }}
            />&nbsp;<label htmlFor='vat-exempted'>VAT Exempted</label>
          </div>
        </div>

        <div className='input-form-container'>
          <label>Percent Discount</label>
          <div className='input-container'>
            <input
              id='percent-discount'
              name='percent_discount'
              value={discount.percent_discount}
              onChange={onChange}
              type='number'/>
          </div>
        </div>
        <div className='input-form-container'>
          <label>Discount Amount</label>
          <div className='input-container'>
            <input
              id='discount-amount'
              name='discount_amount'
              value={discount.discount_amount}
              onChange={onChange}
              type='number'/>
          </div>
        </div>
        <div className='button-container'>
          <button
            onClick={onClickAdd}
            disabled={!addOK}
            className={addOK ? 'pospro-action-btn' : 'pospro-action-btn disabled-button'}>
            { (editDiscount) ? 'Update' : 'Add' }
          </button>
          <button
            style={{display: (editDiscount ? 'block' : 'none')}}
            onClick={onClickCancel}
            className='pospro-action-btn'>
            Cancel
          </button>
        </div>
      </div>
      <DiscountInputStyle />
    </React.Fragment>
  )
}

function DiscountsList(props) {
  const [discountsList, setDiscountsList] = props.discountsList
  const { discountsTotal } = props
  const setDiscount = props.discount[1]
  const [editDiscount, setEditDiscount] = props.editDiscount
  const setEditDiscountItemIndex = props.editDiscountItemIndex[1]

  const onClickDeleteItem = (e) => {
    const current_item_id = e.target.closest('.close-button').id
    setDiscountsList(discountsList.filter((item, index) => index !== parseInt(current_item_id)))
  }

  const onClickEditDiscount = (e) => {
    const highlightItemToEdit = () => {
      const discount_item_containers = document.querySelectorAll('.discount-item-container')
      const delete_item_button_list = document.querySelectorAll('.close-button')
      const current_delete_item_button = delete_item_button_list[current_item.id]

      discount_item_containers.forEach((item, i) => {
        if (i !== parseInt(current_item.id)) {
          item.classList.remove('shadow-discount-item')
          delete_item_button_list[i].style.visibility = 'hidden'
        }
      })

      if (current_delete_item_button)
        current_delete_item_button.style.visibility = 'visible'
      current_item.classList.add('shadow-discount-item')
    }

    const close_button = Boolean(e.target.closest('.close-button'))
    if (close_button) return

    // Get the root element
    const current_item = e.target.parentNode.parentNode
    if (current_item.className === 'discount-item-container') {
      highlightItemToEdit()
      setDiscount({ ...discountsList[current_item.id] })
      setEditDiscount(true)
      setEditDiscountItemIndex(current_item.id)
      document.getElementById('id-number').focus()
    }
  }

  return (
    <React.Fragment>
      <div id='discounts-list-container'>
        <div id='discounts-list-body'>
          {
            (discountsList.length > 0) ?
              discountsList.map((item, index) => (
                <div
                  key={item.id_number}
                  id={index}
                  onClick={onClickEditDiscount}
                  className='discount-item-container'>
                  <div className='discount-item-header'>
                    <label>
                      {item.discount_authority_name}&nbsp;
                      {(item.vat_exempted) ? <span>(VAT Exempted)</span> : null}
                    </label>
                    <div style={{display: (editDiscount) ? 'none' : 'block'}}>
                      <CloseButton id={index} onClick={onClickDeleteItem} />
                    </div>
                  </div>
                  <div className='discount-item'>
                    <label>Date Last Used</label>
                    <span>{(item.discount_date) || '(new)'}</span>
                  </div>
                  <div className='discount-item'>
                    <label>ID Number</label>
                    <span>{item.id_number}</span>
                  </div>
                  <div className='discount-item'>
                    <label>Account Holder's Name</label>
                    <span>{item.account_holder_name}</span>
                  </div>
                  <div className='discount-item'>
                    <label>Percent Discount</label>
                    <span>{formatNumber(item.percent_discount)}%</span>
                  </div>
                  <div className='discount-item'>
                    <label>Discount Amount</label>
                    <span>P {formatNumber(item.discount_amount)}</span>
                  </div>
                </div>
              ))
              : null
          }
        </div>
        <div id='discount-list-total-container'>
          <div className='discount-total'>
            <label>Total Percent Discount</label>
            <span><b>{formatNumber(discountsTotal.total_percent_discount)}%</b></span>
          </div>
          <div className='discount-total'>
            <label>Total Discount Amount</label>
            <span><b>P {formatNumber(discountsTotal.total_discount_amount)}</b></span>
          </div>
        </div>
      </div>
      <DiscountsListStyle />
    </React.Fragment>
  )
}

function DiscountForm(props) {
  const { receiptsList, receipt, setReceipt } =  props

  const totalAmount = receipt.amount_to_pay.total_amount // VAT and Non-VAT
  const totalVATAmount = receipt.amount_to_pay.total_vat_amount

  const initDiscountsTotal = { total_percent_discount: 0.00, total_discount_amount: 0.00 }
  const [discountsTotal, setDiscountsTotal] = useState(initDiscountsTotal)

  // Associates Receipts Date Time Paid on the discounts (re-objected) on the fly
  // This is to know when was the last time this discount was used.
  let discounts = []
  receiptsList.forEach((receipt, i) => {
    if (receipt.discounts) {
      receipt.discounts.items.forEach((discount, i) => {
        discount.discount_date = new Date(receipt.date_time_created).toLocaleString()
        discounts.push(discount)
        // discounts.push({
        //   discount_date: new Date(receipt.receipt_date).toLocaleString(),
        //   ...discount
        // })
      })
    }
  })

  const initDiscount = {
    discount_authority_name: '',
    id_number: '',
    account_holder_name: '',
    percent_discount: 0.00,
    discount_amount: 0.00,
    vat_exempted: false
  }
  const [discount, setDiscount] = useState(initDiscount)
  const [discountsList, setDiscountsList] = useState([])
  const [editDiscount, setEditDiscount] = useState(false)
  const [editDiscountItemIndex, setEditDiscountItemIndex] = useState(null)

  const calcDiscountsTotal = () => {
    if (discountsList.length > 0) {
      const total_percent_discount = discountsList
      .map(item => parseFloat(item.percent_discount))
      .reduce((cur, prev) => cur + prev)

      let total_discount_amount = discountsList
      .map(item => parseFloat(item.discount_amount))
      .reduce((cur, prev) => cur + prev, 0)

      const vat_exempted = Boolean(discountsList.find(discount => discount.vat_exempted))
      if (vat_exempted) total_discount_amount += parseFloat(totalVATAmount)

      setDiscountsTotal({total_percent_discount, total_discount_amount})
    } else setDiscountsTotal(initDiscountsTotal)
  }

  const removeSelection = () => {
    const current_discount_item = document.querySelector('.shadow-discount-item')
    const delete_item_button_list = document.querySelectorAll('.close-button')

    if (current_discount_item)
      current_discount_item.classList.remove('shadow-discount-item')
    delete_item_button_list.forEach((item, i) => {
      if (i !== editDiscountItemIndex)
        item.style.visibility = 'visible'
    })
  }

  const onClickApply = (e) => {
    // Remove discount_date field
    // Not needed on receipts.discounts actual object
    // discountsList.forEach((item, i) => { delete item.discount_date })

    //receipt.discounts = discountsList
    setReceipt({ ...receipt, discounts: { discount_total: discountsTotal, items: discountsList } })

    props.cb('Apply')
  }

  const onClickCancel = (e) => { props.cb('Cancel') }

  const resetDiscount = () => setDiscount(initDiscount)

  /******************************************
   * DiscountInput Components props
   ******************************************/
  const discountInputProps = {
    discount: [discount, setDiscount, resetDiscount, initDiscount],
    discountsList: [discountsList, setDiscountsList],
    editDiscount: [editDiscount, setEditDiscount],
    editDiscountItemIndex: [editDiscountItemIndex, setEditDiscountItemIndex],
    totalAmount,
    totalVATAmount,
    removeSelection,
    calcDiscountsTotal,
    discounts
  }

  /******************************************
   * DiscountList Components props
   ******************************************/
  const discountsListProps = {
    discount: [discount, setDiscount],
    discountsList: [discountsList, setDiscountsList],
    discountsTotal: discountsTotal,
    editDiscount: [editDiscount, setEditDiscount],
    editDiscountItemIndex: [editDiscountItemIndex, setEditDiscountItemIndex],
    vat_percent: receipt.amount_to_pay.vat
  }

  useEffect(() => {
    setDiscountsList(JSON.parse(JSON.stringify(receipt.discounts.items)))
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    calcDiscountsTotal()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discountsList])

  return (
    <React.Fragment>
      <div id='discount-form-container'>
        <div id='discount-form-body'>
          <DiscountInput {...discountInputProps} />
          <DiscountsList {...discountsListProps} />
        </div>
        <div id='discount-form-footer'>
          <button
            disabled={editDiscount}
            onClick={onClickApply}
            className={ editDiscount ? 'pospro-action-btn disabled-button' : 'pospro-action-btn' }>
            Apply
          </button>
          <button
            onClick={onClickCancel}
            className='pospro-action-btn bottom-anchor'>
            Cancel
          </button>
        </div>
      </div>
      <DiscountFormStyle />
    </React.Fragment>
  )
}

export default React.memo(DiscountForm)